import { Box } from "fds";
import "./index.scss";
import SimpleLinkPage from "../../components/SimpleLinkPage";
import { t } from "i18next";
const ErrorPage = () => {
  const urlParams = new URLSearchParams(window.location.search);
  /** UI: 페이지 타이틀 */
  const renderPageTitle = () => {
    const error = urlParams.get("errorCode");
    switch (error) {
      case "NOT_ALLOW_IP":
        return t("login.uidLink.noAllowIp");
      case "NOT_FOUND_USER":
        return t("login.findPW.notFoundUser");
      case "INVALID_TENANCY":
        return t("login.uidLink.tenancyStop");
      case "CLIENT_ERROR":
        return t("login.uidLink.sessionExpired");
      default:
        return t("common.pageNotFound");
    }
  };
  return (
    <Box width={"100%"} height={"100%"} classes={"error"}>
      <SimpleLinkPage
        imagePath={require(urlParams.get("errorCode") &&
          urlParams.get("errorCode") !== "CLIENT_ERROR"
          ? "../../shared/images/common/restrictClient.png"
          : "../../shared/images/common/error.png")}
        pageTitle={renderPageTitle()}
        hasButtonToHome={!urlParams.get("errorCode")}
      />
    </Box>
  );
};

export default ErrorPage;
